export default __webpack_public_path__ + "static/media/subscription.aaf5138b.svg";